import CategoryHeading from './CategoryHeading'

export default CategoryHeading
